
// error
export const ACTION_SET_ERROR = "set_error";
export const ACTION_CLEAR_ERROR = "clear_error";
export const ACTION_CLEAR_ERRORS = "clear_errors";

// live
export const ACTION_SET_LIVE_COUNT = "live_count";
export const ACTION_SET_LIVE_PAGEVIEWS = "live_pageviews";
export const ACTION_SET_LIVE_CONTENTS = "live_contents";

// query data
export const ACTION_SET_QUERY_RESULT = "query_result"
export const ACTION_SET_QUERY_PAGEVIEWS = "query_pageviews";
export const ACTION_SET_QUERY_TOP_POSTS = "query_top_posts";

// wordpress
export const ACTION_ADD_WORDPRESS_CONTENTS = "add_wordpress_contents"

// routes
export const ACTION_SET_ROUTES = "set_routes";

// config
export const ACTION_SET_CONFIG = "config_set_value";

// ui
export const ACTION_SET_UI = "ui_set_value";
export const ACTION_IS_LOADING = "ui_is_loading";

// ---- action builder ----
const buildAction = (actionType, payload)=>({type:actionType, payload});

// ---- ui actions ----
export const actionSetConfig = (key, value) => buildAction(ACTION_SET_CONFIG, {key, value});

// ---- ui actions ----
export const actionSetUi = (key, value) => buildAction(ACTION_SET_UI, {key, value});
export const actionIsLoading = (isLoading, part = "") => buildAction(
	ACTION_IS_LOADING,
	{
		isLoading,
		part
	}
)

// ---- error actions ----
export const actionSetError = (id, error)=> buildAction(ACTION_SET_ERROR, {id, error});
export const actionClearError = (id) => buildAction(ACTION_CLEAR_ERROR, {id});
export const actionClearErrors = ()=>buildAction(ACTION_CLEAR_ERRORS, null);

// ---- live data actions ----
export const actionSetLiveCount = (count) => buildAction(ACTION_SET_LIVE_COUNT, count);
export const actionSetLivePageviews = (pageviews)=> buildAction(ACTION_SET_LIVE_PAGEVIEWS, pageviews)

// -------------------------------------
// oql query related
// -------------------------------------
export const actionSetQueryResult = (id, data)=> buildAction(ACTION_SET_QUERY_RESULT,{id, data})

// -------------------------------------
// wordpress related
// -------------------------------------
export const actionWordPressAddContents  = (contents)=> buildAction(ACTION_ADD_WORDPRESS_CONTENTS, contents)

// -------------------------------------
// routes related
// -------------------------------------
export const actionSetRoutes = (routerId, routes) => buildAction(ACTION_SET_ROUTES, {routerId, routes})